import columns from '../../../../../react-table/helpers/columns';

export const toggleRowButtonProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo &&
    (!rowInfo.row.receptacleIds || rowInfo.row.receptacleIds.length < 2)) {
    className = 'not-expandable';
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    ToggleRowButtonColumn,
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    MultilineColumn,
    MultilineExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ToggleRowButtonColumn().withGetProps(toggleRowButtonProps),
        new TextColumn('Registered carrier', 'registeredCarrier'),
        new TextColumn('Registered flight', 'registeredFlight'),
        new TextColumn('MRD location', 'mrdLocation'),
        new TextColumn('Origin', 'origin'),
        new TextColumn('Handler', 'handler'),
        new TextColumn('MRD label', 'mrdLabel'),
        new MultilineExternalReceptacleLinkColumn('Unit ID / receptacle ID', 'receptacleIds')
          .withWidth(300)
          .withExpandable('non-clickable-first-link'),
        new MultilineColumn('Attributed carrier', 'attributedCarrier')
          .withExpandable('non-clickable-first-link'),
        new DateTimeColumn('Handover date', 'handoverDate'),
        new DateTimeColumn('Actual arrival', 'actualArrivalDate'),
        new TextColumn('Reg. vs arr. (d hh:mm)', 'registeredVsArrived'),
        new NonZeroNumberColumn('Attributed receptacles', 'attributedReceptacles'),
        new NonZeroNumberColumn('Weight (kg) attr. rcpts.', 'weightAttributedReceptacles'),
      ],
    },
  ];
};
